export const ru = {
    'error-title': 'Не удалось изменить заголовок',
    'error-title-validation': 'Ошибка валидации',
    'updated-title': 'Обновлено'
};
